import { render, staticRenderFns } from "./appltCourse.vue?vue&type=template&id=7d4dc4bc"
import script from "./appltCourse.vue?vue&type=script&lang=js"
export * from "./appltCourse.vue?vue&type=script&lang=js"
import style0 from "./appltCourse.vue?vue&type=style&index=0&id=7d4dc4bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports